import { gql } from 'gql/__generated__'

export const projectAndGroupTrashCountSubscription = gql(`
    subscription ProjectAndGroupTrashCountSubscription($companyId: String!) {
      data: projectAndGroupTrashCount(companyId: $companyId) {
        count
      }
    }
  `)
